import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faBars } from "@fortawesome/free-solid-svg-icons";
import HamburgerMenu from "../HamburgerMenu/HamburgerMenu";
import styles from "./ScreenHeader.module.css";

function ScreenHeader({ title, showBack = true, showMenu = false }) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigate = useNavigate();

  return (
    <>
      <header className={styles.header}>
        <div className={styles.side}>
          {showBack ? (
            <button className={`${styles.iconButton} ${styles.backButton}`} onClick={() => navigate(-1)} aria-label="Volver">
              <FontAwesomeIcon icon={faArrowLeft} />
              <span>Volver</span>
            </button>
          ) : (
            <div className={styles.spacer} />
          )}
        </div>

        <h1 className={styles.title}>{title}</h1>

        <div className={styles.side}>
          {showMenu ? (
            <button
              className={`${styles.iconButton} ${styles.menuButton}`}
              onClick={() => setIsMenuOpen(true)}
              aria-label="Abrir menú"
            >
              <FontAwesomeIcon icon={faBars} />
            </button>
          ) : (
            <div className={styles.spacer} />
          )}
        </div>
      </header>

      {showMenu && (
        <HamburgerMenu isOpen={isMenuOpen} onClose={() => setIsMenuOpen(false)} />
      )}
    </>
  );
}

export default ScreenHeader;
